import React from 'react';

export const BlockBgIcon = (props) => {
  return (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="35" height="35" rx="11" fill="#F8F9FC" />
      <path
        d="M28 16.8057C28 17.2686 28 17.7314 28 18.1943C27.9635 18.4501 27.9391 18.7059 27.9026 18.9617C27.598 21.0203 26.7819 22.8353 25.4055 24.3944C23.7245 26.3068 21.6172 27.4762 19.0835 27.866C18.7912 27.9147 18.4867 27.9513 18.1943 27.9878C17.7314 27.9878 17.2686 27.9878 16.8057 27.9878C16.7448 27.9756 16.6839 27.9513 16.623 27.9513C16.1966 27.8904 15.7581 27.8538 15.3318 27.7686C13.127 27.2935 11.2633 26.2216 9.7529 24.565C8.31555 23.0058 7.43852 21.1787 7.12181 19.0835C7.07309 18.7912 7.03654 18.4867 7 18.1943C7 17.7314 7 17.2686 7 16.8057C7.03654 16.5621 7.0609 16.3063 7.09745 16.0626C7.40197 14.0041 8.2181 12.1647 9.59455 10.6056C11.2877 8.68097 13.395 7.52378 15.9165 7.12181C16.2088 7.07309 16.5133 7.03654 16.8057 7C17.2686 7 17.7314 7 18.1943 7C18.4379 7.03654 18.6937 7.0609 18.9374 7.09745C21.0081 7.40197 22.8474 8.23028 24.4066 9.61891C26.3068 11.2999 27.464 13.4072 27.866 15.9165C27.9269 16.2088 27.9513 16.5012 28 16.8057ZM11.5191 24.2361C14.8324 27.2691 20.5087 27.5006 24.1021 23.6392C27.6589 19.8266 26.9768 14.4182 24.2361 11.5191C19.9971 15.7581 15.7703 19.9971 11.5191 24.2361ZM23.1398 10.4594C19.4002 7.47506 14.0284 7.88921 10.837 11.4095C7.57251 15.0029 7.91357 20.0824 10.4716 23.1398C14.6862 18.913 18.913 14.6862 23.1398 10.4594Z"
        fill="url(#paint0_linear_3308_3271)"
        stroke="url(#paint1_linear_3308_3271)"
        strokeWidth="0.2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3308_3271"
          x1="7.53571"
          y1="9.94566"
          x2="27.8956"
          y2="10.2932"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#D19985" />
          <stop offset="1" stopColor="#FFBEA3" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3308_3271"
          x1="7.53571"
          y1="9.94566"
          x2="27.8956"
          y2="10.2932"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#D19985" />
          <stop offset="1" stopColor="#FFBEA3" />
        </linearGradient>
      </defs>
    </svg>
  );
};
